export default __webpack_public_path__ + "static/media/OpenSans-ExtraBoldItalic.58946b25.ttf";